import React, { useRef, useEffect } from "react"
import L from "leaflet"
import Modal from "../shared/Modal"
import { initMap, createMapMarkers, addUserMarker } from "../../helpers/mapStyles"
import { stripAugmentation } from "../../helpers/choices"
import useMapRecenter from "../../hooks/useMapRecenter"

const DEFAULT_MARKER_COLOR = "#e74c3c"

const findSliceColor = (slices, name) =>
  slices?.find((s) => stripAugmentation(s.text) === name)?.color || DEFAULT_MARKER_COLOR

const MapModal = ({ markers, winner, userCoords, slices, onClose }) => {
  const mapRef = useRef(null)
  const { mapInstanceRef, boundsRef, handleRecenter } = useMapRecenter()

  useEffect(() => {
    if (!mapRef.current || markers.length === 0) return

    const map = initMap(L, mapRef.current)
    mapInstanceRef.current = map
    const winnerName = winner ? stripAugmentation(winner.text) : null

    const leafletMarkers = createMapMarkers(L, map, markers, {
      colorFn: (m) => findSliceColor(slices, m.name),
      winnerName,
    })

    const bounds = L.featureGroup(leafletMarkers).getBounds().pad(0.1)
    boundsRef.current = bounds
    map.fitBounds(bounds)

    if (userCoords) {
      addUserMarker(L, map, userCoords)
    }

    return () => map.remove()
  }, [markers, winner, userCoords, slices])

  return (
    <Modal title="Map View" onClose={onClose} className="modal-wide">
      <div className="map-wrapper">
        <div ref={mapRef} className="map-container" />
        <button className="map-recenter-btn" onClick={handleRecenter} title="Recenter map">
          Recenter
        </button>
      </div>
    </Modal>
  )
}

export default MapModal
